/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const CMacro = require('./CMacro')
module.exports = CMacroAffectationPointLie

/**
 * Macro envoyant un point lié sur un autre point lié au même objet.
 * @constructor
 * @extends CMacro
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
 * @param {Boolean} estElementFinal : true si l'objet est un élément final de construction.
 * @param {mtg32.Color} couleur : La couleur d'éciture de l'éditeur (et du cadre éventuel).
 * @param {Float} x_nom : L'abscisse d'affichage de la macro
 * @param {Float} y_nom : L'ordonnée d'affichage de la macro
 * @param {Integer} dec_x : Décalage horizontal du nom
 * @param {Integer} dec_y : Décalage vertical du nom
 * @param {Boolean} masque : true si l'éditeur est masqué
 * @param {CPt} pointLie : null ou pointe sur un point auquel l'affichage est lié.
 * @param {Integer} taillePolice : Indice de la taiile de police utilisée
 * @param {Boolean} effacementFond : true si on efface le fond de l'en-tête.
 * @param {mtg32.Color} couleurFond : La couleur de fond de l'en-tête.
 * @param {Integer} alignementHorizontal : 0 pour alignement gauche, 1 pour centre, 2 pour droite.
 * @param {Integer} alignementVertical : 0 pour alignement vers le haut, 1 pour centré, 2 pour bas.
 * @param {String} intitule : Le titre de la macro
 * @param {String} commentaireMacro : Eventuel commentaire explicatif.
 * @param {type} pointLieAPositionner
 * @param {type} pointLieAssocie
 * @returns {CMacroAffectationPointLie}
 */
function CMacroAffectationPointLie (listeProprietaire, impProto, estElementFinal, couleur,
    x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond,
    alignementHorizontal, alignementVertical, intitule, commentaireMacro, pointLieAPositionner, pointLieAssocie) {
  if (arguments.length !== 0) {
    if (arguments.length === 1) CMacro.call(this, listeProprietaire);
    else {
      CMacro.call(this, listeProprietaire, impProto, estElementFinal, couleur,
        x_nom, y_nom, dec_x, dec_y, masque, pointLie, taillePolice, effacementFond, couleurFond,
        alignementHorizontal, alignementVertical, intitule, commentaireMacro);
      this.pointLieAPositionner = pointLieAPositionner;
      this.pointLieAssocie = pointLieAssocie;
    }
  }
}
CMacroAffectationPointLie.prototype = new CMacro();
CMacroAffectationPointLie.prototype.constructor = CMacroAffectationPointLie;
CMacroAffectationPointLie.prototype.superClass = "CMacro";
CMacroAffectationPointLie.prototype.className = "CMacroAffectationPointLie";

CMacroAffectationPointLie.prototype.getClone = function(listeSource, listeCible) {
  var ind1 = listeSource.indexOf(this.pointLieAPositionner);
  var ind2 = listeSource.indexOf(this.pointLieAssocie);
  var ind3 = listeSource.indexOf(this.pointLie);
  var ind4 = listeSource.indexOf(this.impProto);
  return new CMacroAffectationPointLie(listeCible, listeCible.get(ind4, "CImplementationProto"),
    this.estElementFinal, this.couleur, this.x_nom, this.y_nom, this.dec_x, this.dec_y, this.masque,
    listeCible.get(ind3, "CPt"), this.taillePolice, this.effacementFond, this.couleurFond,
    this.alignementHorizontal, this.alignementVertical,
    this.intitule, this.commentaireMacro, listeCible.get(ind1, "CPointLie"),
    listeCible.get(ind2, "CPointLie"));
};
CMacroAffectationPointLie.prototype.dependDe = function(p) {
  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
  return this.memoriseDependance(CMacro.prototype.dependDe.call(this, p) ||
    this.pointLieAPositionner.dependDe(p) || this.pointLieAssocie.dependDe(p));
};
CMacroAffectationPointLie.prototype.dependDePourBoucle = function(p) {
  return (CMacro.prototype.dependDePourBoucle.call(this, p) || this.pointLieAPositionner.dependDePourBoucle(p) ||
    this.pointLieAssocie.dependDePourBoucle(p));
};
CMacroAffectationPointLie.prototype.executionPossible = function() {
  return this.pointLieAPositionner.existe && this.pointLieAssocie.existe;
};
CMacroAffectationPointLie.prototype.execute = function(svg, dimf, couleurFond, transparence) {
  this.pointLieAPositionner.donneAbscisse(this.pointLieAssocie.abscisse);
  this.listeProprietaire.positionne(false, dimf);
  this.listeProprietaire.update(svg, couleurFond, transparence, true);
  this.termineAction(svg, dimf, couleurFond, transparence);
};
CMacroAffectationPointLie.prototype.remplacePoint = function(ancienPoint, nouveauPoint) {
  if (this.pointLieAssocie === ancienPoint) this.pointLieAssocie = nouveauPoint;
  if (this.pointLieAPositionner === ancienPoint) this.pointLieAPositionner = nouveauPoint;
};
CMacroAffectationPointLie.prototype.ajouteAntecedents = function(liste) {
  liste.add(this.pointLieAPositionner);
  liste.add(this.pointLieAssocie);
};
CMacroAffectationPointLie.prototype.read = function(inps, list){
  CMacro.prototype.read.call(this, inps, list);
  var ind1 = inps.readInt();
  this.pointLieAPositionner = list.get(ind1,"CPointLie");
  var ind2 = inps.readInt();
  this.pointLieAssocie = list.get(ind2,"CPointLie");
};
CMacroAffectationPointLie.prototype.write = function(oups, list){
  CMacro.prototype.write.call(this, oups, list);
  var ind1 = list.indexOf(this.pointLieAPositionner);
  oups.writeInt(ind1);
  var ind2 = list.indexOf(this.pointLieAssocie);
  oups.writeInt(ind2);
};



// WEBPACK FOOTER //
// ./src/objets/CMacroAffectationPointLie.js